module.exports = __webpack_public_path__ + "img/logo-symbol__white.2cd73f5e.png";